export const THEME_STORAGE_KEY = "@ui:theme";

const DARK_QUERY = "(prefers-color-scheme: dark)";

// A cor da barra do navegador acompanha o tema: no claro é a marca, no escuro
// é o canvas — verde vivo colado a uma janela escura lê como erro de render.
const THEME_COLOR = {
  light: "#137647",
  dark: "#131316",
};

// "Sistema" não é gravado: a ausência da chave já significa seguir o SO, e
// gravá-la exigiria um terceiro valor que o resolver teria de reconhecer.
export function readStoredTheme() {
  const stored = localStorage.getItem(THEME_STORAGE_KEY);
  return stored === "light" || stored === "dark" ? stored : null;
}

export function storeTheme(preference) {
  if (preference === "light" || preference === "dark") {
    localStorage.setItem(THEME_STORAGE_KEY, preference);
    return;
  }
  localStorage.removeItem(THEME_STORAGE_KEY);
}

export function prefersDark() {
  return window.matchMedia(DARK_QUERY).matches;
}

export function subscribeToColorScheme(onChange) {
  const query = window.matchMedia(DARK_QUERY);

  query.addEventListener("change", onChange);
  return () => query.removeEventListener("change", onChange);
}

export function resolveTheme(preference, systemPrefersDark) {
  if (preference === "light" || preference === "dark") return preference;
  return systemPrefersDark ? "dark" : "light";
}

// O atributo nunca recebe "system": o resolver decide antes, e com isso a
// paleta escura mora num seletor só, sem um @media espelhando os 47 tokens.
export function applyTheme(resolved) {
  document.documentElement.dataset.theme = resolved;

  const meta = document.querySelector('meta[name="theme-color"]');
  if (meta) meta.setAttribute("content", THEME_COLOR[resolved]);
}
